export const getInvoices = `
  query getInvoices($status: InvoiceStatus){
    getInvoices(status: $status){
      amountDue
      created
      currency
      description
      dueDate
      invoiceId
      invoiceNumber
      periodStart
      periodEnd
      product
      status
    }
  }
`

export const getPaymentPortalLink = `
  query getPaymentPortalLink($returnUrl: String){
    getPaymentPortalLink(returnUrl: $returnUrl)
  }
`

export const getPaymentCheckoutLink = `
  query getPaymentCheckoutLink($priceId: String, $cancelUrl: String, $successUrl: String) {
    getPaymentCheckoutLink(priceId: $priceId, cancelUrl: $cancelUrl, successUrl: $successUrl)
  }
`

export const getSubscriptionData = `
  query getSubscriptionData {
    getSubscriptionData {
      productName
      periodStart
      periodEnd
      interval
      metadata {
        groupId
      }
    }
  }
`

export const cancelSubscription = `
  mutation cancelSubscription {
    cancelSubscription{
      cancelAtPeriodEnd
      metadata {
        groupId
      }
    }
  }
`

export const cancelUnsubscription = `
  mutation cancelUnsubscription {
    cancelUnsubscription{
      cancelAtPeriodEnd
      metadata {
        groupId
      }
    }
  }
`


